import { sendEvent } from 'constants/mixpanelHelper';
import { GENERIC_EVENTS, REVIEW_EVENTS } from 'constants/trackingEvents';

// export const sendMyReviewsTableEvent = ({
//   eventName = REVIEW_EVENTS.MY_REVIEWS_TABLE,
//   eventProperties = {}
// }) => {
//   sendEvent({ eventName, eventProperties });
// };

export const sendViewReviewListEvent = ({ eventName = REVIEW_EVENTS.VIEWED_REVIEW_LIST, eventProperties = {} }) => {
  sendEvent({ eventName, eventProperties });
};

export const sendSelectedReviewCycleEvent = ({
  eventName = REVIEW_EVENTS.SELECTED_REVIEW_CYCLE,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendSelectedReviewInstanceEvent = ({
  eventName = REVIEW_EVENTS.SELECTED_REVIEW_INSTANCE,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReviewCalibrationOpenEvent = ({
  eventName = REVIEW_EVENTS.REVIEW_CALIBRATION_SIDEPANEL_OPEN,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendNavigatedToReviewsEvent = ({
  eventName = REVIEW_EVENTS.NAVIGATED_TO_REVIEWS,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendDownloadReviewCSVEvent = ({ eventName = GENERIC_EVENTS.DOWNLOAD_CSV, eventProperties = {} }) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnStartReviewEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_ON_START_REVIEW,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnContinueReviewEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_ON_CONTINUE_REVIEW,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendRespondedToReviewRequestEvent = ({
  eventName = REVIEW_EVENTS.RESPONDED_TO_REVIEW_REQUEST,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendClickedOnAcknowledgeEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_ON_ACKNOWLEDGE,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendClickedOnEditNominationsEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_ON_EDIT_NOMINATION,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendClickedOnNominateEvent = ({ eventName = REVIEW_EVENTS.CLICKED_ON_NOMINATE, eventProperties = {} }) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnWithdraw = ({ eventName = REVIEW_EVENTS.CLICKED_ON_WITHDRAW, eventProperties = {} }) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedCompletedByMeViewDetailsEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_COMPLETED_BY_ME_VIEW_DETAILS,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedPastReviewsViewDetailsEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_PAST_REVIEWS_VIEW_DETAILS,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendChangeWeightageEvent = ({ eventName = REVIEW_EVENTS.CHANGE_WEIGHTAGE, eventProperties = {} }) => {
  sendEvent({ eventName, eventProperties });
};

export const sendChangeInsightsTimelineEvent = ({
  eventName = REVIEW_EVENTS.CHANGE_WEIGHTAGE,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReCalibrateEvent = ({ eventName = REVIEW_EVENTS.RECALIBRATE, eventProperties = {} }) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnSaveReCalibrationEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_ON_SAVE_RECALIBRATION,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnCancelReCalibrationEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_ON_CANCEL_RECALIBRATION,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendViewFormEvent = ({ eventName = REVIEW_EVENTS.VIEW_FORM, eventProperties = {} }) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReopenFormEvent = ({ eventName = REVIEW_EVENTS.REOPEN_FORM, eventProperties = {} }) => {
  sendEvent({ eventName, eventProperties });
};

export const sendPublishEvent = ({ eventName = REVIEW_EVENTS.PUBLISH, eventProperties = {} }) => {
  sendEvent({ eventName, eventProperties });
};

export const sendUnpublishEvent = ({ eventName = REVIEW_EVENTS.UNPUBLISH, eventProperties = {} }) => {
  sendEvent({ eventName, eventProperties });
};

export const sendForceSubmitEvent = ({ eventName = REVIEW_EVENTS.CLICKED_ON_FORCE_SUBMIT, eventProperties = {} }) => {
  sendEvent({ eventName, eventProperties });
};

export const sendNotifyEvent = ({ eventName = REVIEW_EVENTS.CLICKED_ON_NOTIFY, eventProperties = {} }) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOpenedReviewFormEvent = ({
  eventName = REVIEW_EVENTS.OPENED_REVIEW_FORM,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedBackReviewFormEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_BACK_REVIEW_FORM,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedNextReviewFormEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_NEXT_REVIEW_FORM,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendAnsweredReviewQuestionEvent = ({
  eventName = REVIEW_EVENTS.ANSWERED_REVIEW_QUESTION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

// ----------------- Review Form Events -----------------

export const sendSubmittedReviewFormEvent = ({
  eventName = REVIEW_EVENTS.SUBMITTED_REVIEW_FORM,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedReviewsFAQEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_REVIEWS_FAQ,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedPastReviewsEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_VIEW_PAST_REVIEWS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedManageGoalWeightageEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_MANAGE_GOAL_WEIGHTAGE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOpenedCompetencyPanelEvent = ({
  eventName = REVIEW_EVENTS.OPENED_COMPETENCY_PANEL,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendChangedFormSectionEvent = ({
  eventName = REVIEW_EVENTS.CHANGED_FORM_SECTION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedNextQuestionEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_NEXT_QUESTION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedPreviousQuestionEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_PREVIOUS_QUESTION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedReviewContextEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_REVIEW_CONTEXT,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOpenedFeedbackReceivedPanelEvent = ({
  eventName = REVIEW_EVENTS.OPENED_FEEDBACK_RECEIVED_PANEL,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};
